import { Logger } from "@hoylu/login-common";

export function createIframe(src: string, id: string, log?: Logger) {
    if (document.getElementById(id)) {
        log?.error(`iframe already exists: ${id}`)
        return;
    }
    let frame = document.body.appendChild(document.createElement('iframe'));
    if (!frame) {
        log?.error(`appendChild for iframe ${id} did not return window handle`);
    } else {
        log?.info(`iframe created for ${id} with src: ${src}`);
    }
    frame.src = src;
    frame.id = id;
    frame.style.visibility = 'hidden';
    frame.style.width = '0px';
    frame.style.height = '0px';
    frame.style.position = 'absolute';
    frame.style.top = '0';
    frame.style.left = '0';
    return frame;
}
